import { Alert, Button } from "@/components";
import { useDesignMaxTheme, useModal } from "@/packages";
import { createRandomString } from "@/utils";
import { Center, Flex, Text } from "@chakra-ui/react";
import { useCheckInValue, useCheckOutValue, useSelectedRoomValue } from "@shared/client";
import { FONT } from "@styles/common";
import { useEffect } from "react";
import { useBookParameter } from "./hooks";

export const BookBar = () => {
    const checkIn = useCheckInValue();
    const checkOut = useCheckOutValue();
    const selectedRooms = useSelectedRoomValue();
    const { mutation, isLoading } = useBookParameter();
    const { openModal, setModalContent } = useModal();
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const { isLaptop, isTablet } = MEDIAS();

    // 선택한 객체 배열 중 필요한 값들만 파싱
    const roomIdxGroup = selectedRooms.map((room) => room.roomIdx).join("|");
    const adultGroup = selectedRooms.map((room) => room.person?.adult).join("|");
    const childGroup = selectedRooms.map((room) => room.person?.child).join("|");
    const infantGroup = selectedRooms.map((room) => room.person?.infant).join("|");

    const finalBookPrice = selectedRooms.reduce((acc, cur) => acc + cur.newOffPrice, 0);
    const laptopPadding = isLaptop ? "0 44px" : "0 24px";

    const handleBookStart = () => {
        if (checkOut) {
            const uid = createRandomString(6);
            const params = {
                uid,
                checkInDate: checkIn,
                checkOutDate: checkOut,
                roomIdx: roomIdxGroup,
                adult: adultGroup,
                child: childGroup,
                infant: infantGroup,
                section: "booking",
                page: "reserve",
            };

            mutation.mutate(params);
        }
    };

    useEffect(() => {
        if (isLoading) {
            setModalContent(<Alert>결제 페이지로 이동중 입니다...</Alert>);
            openModal();
        }
    }, [isLoading]);

    return (
        <Center
            w="100%"
            h="72px"
            position="sticky"
            justifyContent="flex-end"
            bottom="0"
            bgColor={COLORS.white}
            boxShadow="0 -4px 8px rgba(0,0,0,0.1)"
        >
            <Center
                w="100%"
                maxW="1400px"
                p={isTablet ? "0 20px" : laptopPadding}
                m="0 auto"
                justifyContent="flex-end"
                columnGap="24px"
                sx={{
                    "& button": {
                        ...FONT("pretendard", 16, 700),
                        color: COLORS.pink,
                        border: "1px solid",
                        borderColor: COLORS.pink,
                        "&:hover": {
                            color: COLORS.white,
                            bgColor: COLORS.pink,
                            border: "none",
                        },
                    },
                }}
            >
                <Flex sx={{ ...FONT("pretendard", 16, 500) }} columnGap="4px" alignItems="center">
                    <Text>총</Text>
                    <Text as="span" color={COLORS.pink} sx={{ ...FONT("pretendard", 24, 700) }}>
                        {finalBookPrice.toLocaleString()}
                    </Text>
                    <Text>원</Text>
                </Flex>
                <Button size="medium" disabled={finalBookPrice === 0} onClick={handleBookStart}>
                    예약하기
                </Button>
            </Center>
        </Center>
    );
};
